
import { Component, Prop, Vue } from "vue-property-decorator";
import QaAnswerContent from "@/components/QA/QaAnswerContent.vue";
import QaFeedback from "@/components/QA/QaFeedback.vue";
import { QaItem } from "@/models/QaAnswer";

@Component({
  components: { QaAnswerContent, QaFeedback },
})
export default class Answer extends Vue {
  @Prop() questionObj: QaItem;
}
